<template>
  <div
    :class="css"
    :style="style"
  />
</template>

<script>
// import { TimelineLite } from 'gsap'
// import { avatarSize } from './constants'

export default {
  name: 'SkeletonPlaceholder',
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    width: {
      type: Number,
      default: 0,
    },
    showGutter: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      mounted: false,
      timeline: null,
    }
  },
  computed: {
    css() {
      return {
        'km-skeleton__gutter': this.showGutter,
      }
    },
    style() {
      // if (!this.loading) {
      //   return
      // }
      // return {
      //   backgroundSize: `${this.width * 2}px ${avatarSize}px`,
      // }
      return {}
    },
  },
  watch: {
    // loading() {
    //   if (this.loading) {
    //     this.showLoading()
    //   } else {
    //     this.hideLoading()
    //   }
    // },
    // mounted() {
    //   if (this.loading) {
    //     this.showLoading()
    //   } else {
    //     this.hideLoading()
    //   }
    // },
  },
  mounted() {
    // this.mounted = true
  },
  methods: {
    showLoading() {
      // if (this.timeline) {
      //   this.timeline.resume()
      //   return
      // }
      //
      // this.timeline = new TimelineLite({
      //   onComplete: () => this.timeline.restart(),
      // })
      //
      // this.timeline.fromTo(
      //   this.$el,
      //   1,
      //   {
      //     backgroundPosition: `-${this.width}px 0`,
      //   },
      //   {
      //     backgroundPosition: `${this.width}px 0`,
      //   },
      // )
    },
    hideLoading() {
      // this.timeline && this.timeline.pause()
    },
  },
}
</script>
